import { Component, OnInit, Inject, Injectable } from '@angular/core';
import {MatDialogRef as MatDialogRef, MAT_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/dialog';
import { BehaviorSubject } from 'rxjs';
import { UserApiService } from '../../user-api.service';

@Component({
  selector: 'app-user-transaction-history',
  templateUrl: './user-transaction-history.component.html',
  styleUrls: ['./user-transaction-history.component.css']
})
@Injectable()
export class UserTransactionHistoryComponent implements OnInit {
  userId: number = 0;
  constructor(private dialogRef:
    MatDialogRef<UserTransactionHistoryComponent>,
    private userService: UserApiService,
    @Inject(MAT_DIALOG_DATA) data) {
    this.userId = data.userId
  }
  private activeHistory: BehaviorSubject<any> = new BehaviorSubject(1)
  public activeHistory$ = this.activeHistory.asObservable();


  ngOnInit() {
  }


  
  switchActiveTab(navigateTo) {;
    this.activeHistory.next(navigateTo);
  }

  close() {
    this.dialogRef.close();
  }
}
